/**
Below is the custom CSS used. To ensure it isn't lost during a theme update, I’ve added it to the custom.js file instead of a custom.css file.
Since custom.js is not replaced during theme updates, this approach helps preserve all custom styling.

Any issues or questions please reach out to Swift Productions on the details below
Web: www.swiftproductions.com.au
email: sales@swiftproductions.com.au
phone: 1300 55 85 86
**/

const style = document.createElement("style");
style.textContent = `
.mega-menu__inner {
    /* justify-content: safe center; */
    /* column-gap: var(--mega-menu-column-gap); */
    /* max-height: calc(100vh - var(--header-height, 0px) - var(--announcement-bar-height, 0px) - 50px); */
    z-index: 1;
    /* grid-auto-flow: column; */
    /* padding-block-start: 48px; */
    /* padding-block-end: 48px; */
    /* display: grid; */
    /* position: relative; */
    overflow: auto;
    /* align-items: baseline; */
}

.mega-menu__column {
    margin: 20px;
    display: inline;
    float: left;
    height: auto;
    width: 21%;
}

.mega-menu__columns-wrapper {
    margin: 0;
    display: inline-table;
    /* flex-wrap: wrap; */
    /* align-content: flex-start; */
    /* justify-content: center; */
}


#shopify-section-sections--19053043613921__newsletter_6VGCmp .image-with-text-block__image-wrapper {
  background: #68001b;
}

#shopify-section-sections--19053043613921__newsletter_6VGCmp h2.heading {
  font-size:25px;
}



#shopify-section-sections--19053043613921__newsletter_6VGCmp .input__field {
    background: #fff;
}

#shopify-section-sections--19053043613921__newsletter_6VGCmp .input__label {
    background: transparent;
    color: #5a5a5a;
}

#shopify-section-sections--19053043613921__newsletter_6VGCmp .input-row .button {
    border: 1px solid;
}

#shopify-section-sections--19053043613921__newsletter_6VGCmp :focus-within~.input__label,
#shopify-section-sections--19053043613921__newsletter_6VGCmp .is-filled~.input__label {
    transform: scale(.733) translateY(calc(-37px - .5em)) translate(3.665px);
    color: #fff !important;
}

#shopify-section-sections--19053043613921__newsletter_6VGCmp .image-with-text-block__content {
    padding-inline-start: 10px;
    padding-inline-end: 10px;
    padding:10px;
}

#shopify-section-template--19053043056865__video_with_text_9fK7Uy {
    padding: 60px 0 50px;
}

footer {
  border-top: 2px solid #fff;
}

footer .footer__inner {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
}


#shopify-section-template--19053043056865__video_with_text_9fK7Uy {
background: #fff;
}

@media screen and (min-width: 1300px) {
    .text-with-icons__list {
      gap: 17px;
    }
}

@media screen and (min-width: 1200px) {
  #shopify-section-sections--19053043613921__newsletter_6VGCmp .image-with-text-block--small {
        min-height: 300px;
    }

  #shopify-section-sections--19053043613921__newsletter_6VGCmp .content-box--small {
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
    }
}

@media screen and (min-width: 1000px) {
    .text-with-icons__list {
        grid-auto-columns: minmax(185px, 400px);
        gap: 32px;
        display: flex;
    }
    .text-with-icons__item {
      width: 110px
    }
}

/* Product Recommendations Mobile Optimization */
@media screen and (max-width: 999px) {
    .product-list__inner--scroller {
        grid-auto-columns: 30vw !important;
        gap: 12px !important;
        scroll-snap-type: x mandatory !important;
        scroll-behavior: smooth !important;
    }
    
    .product-item {
        scroll-snap-align: start !important;
    }
    
    /* Show navigation arrows on mobile - let theme handle the functionality */
    .product-list__prev-next.hidden-pocket {
        display: flex !important;
    }
    
    /* Make add to cart button text smaller on mobile product recommendations */
    product-recommendations .product-item .button--outline .loader-button__text {
        font-size: 11px !important;
        line-height: 1.2 !important;
    }
    
    product-recommendations .product-item .button--outline {
        padding: 8px 6px !important;
        min-height: auto !important;
    }
}

@media screen and (min-width: 741px) and (max-width: 999px) {
    .product-list__inner--scroller {
        grid-auto-columns: 22vw !important;
        gap: 16px !important;
    }
}

/* Text with Icons Mobile Optimization - Show first 3 icons in single row */
@media screen and (max-width: 999px) {
    .text-with-icons__list {
        display: grid !important;
        grid-template-columns: repeat(3, 1fr) !important;
        gap: 1px !important;
        padding: 4px !important;
        margin: 0 !important;
    }
    
    .text-with-icons__item {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        text-align: center !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    
    /* Show only first 3 items, hide the rest */
    .text-with-icons__item:nth-child(n+4) {
        display: none !important;
    }
    
    /* Show first 3 items even if they have hidden attribute */
    .text-with-icons__item:nth-child(-n+3) {
        display: flex !important;
    }
    
    .text-with-icons__custom-icon {
        max-width: 28px !important;
        width: 28px !important;
        height: 28px !important;
        margin: 0 !important;
    }
    
    .text-with-icons__content-wrapper {
        padding: 0 !important;
        margin: 0 !important;
    }
    
    .text-with-icons__content-wrapper p {
        font-size: 10px !important;
        line-height: 1.1 !important;
        margin: 1px 0 0 0 !important;
        padding: 0 !important;
    }
    
    .text-with-icons__dots {
        display: none !important;
    }
}

/* Announcement Bar Mobile Optimization - Remove padding to keep single line */
@media screen and (max-width: 999px) {
    .announcement-bar__list {
        padding-inline-start: 0 !important;
        padding-inline-end: 0 !important;
    }
}
`;

document.head.appendChild(style);


/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Mobile Breadcrumb Dropdown Functionality
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, looking for breadcrumb triggers...');
    const breadcrumbTriggers = document.querySelectorAll('.breadcrumb-mobile-trigger');
    console.log('Found triggers:', breadcrumbTriggers.length);

    breadcrumbTriggers.forEach(function(trigger) {
        const dropdownId = trigger.getAttribute('aria-controls');
        const dropdown = document.getElementById(dropdownId);
        console.log('Setting up trigger with dropdown ID:', dropdownId);

        if (trigger && dropdown) {
            // Use data attribute instead of aria-expanded to avoid conflicts
            trigger.setAttribute('data-expanded', 'false');
            dropdown.setAttribute('aria-hidden', 'true');

            // Toggle dropdown on click
            trigger.addEventListener('click', function(e) {
                console.log('CLICK DETECTED!');
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = trigger.getAttribute('data-expanded') === 'true';
                console.log('Before toggle - data-expanded:', trigger.getAttribute('data-expanded'));
                console.log('Before toggle - aria-hidden:', dropdown.getAttribute('aria-hidden'));

                // Close all other dropdowns first
                closeAllBreadcrumbDropdowns();

                if (!isExpanded) {
                    console.log('Opening dropdown...');
                    openBreadcrumbDropdown(trigger, dropdown);
                    console.log('After open - data-expanded:', trigger.getAttribute('data-expanded'));
                    console.log('After open - aria-hidden:', dropdown.getAttribute('aria-hidden'));
                } else {
                    console.log('Dropdown was already open, now closed');
                }
            });
        } else {
            console.log('Missing trigger or dropdown:', { trigger, dropdown, dropdownId });
        }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.breadcrumb-mobile-container')) {
            closeAllBreadcrumbDropdowns();
        }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeAllBreadcrumbDropdowns();
        }
    });

    function openBreadcrumbDropdown(trigger, dropdown) {
        trigger.setAttribute('data-expanded', 'true');
        dropdown.setAttribute('aria-hidden', 'false');
    }

    function closeBreadcrumbDropdown(trigger, dropdown) {
        trigger.setAttribute('data-expanded', 'false');
        dropdown.setAttribute('aria-hidden', 'true');
    }

    function closeAllBreadcrumbDropdowns() {
        breadcrumbTriggers.forEach(function(trigger) {
            const dropdownId = trigger.getAttribute('aria-controls');
            const dropdown = document.getElementById(dropdownId);
            if (trigger && dropdown) {
                closeBreadcrumbDropdown(trigger, dropdown);
            }
        });
    }
});